import PropTypes from 'prop-types';
import React from 'react';
import createReactClass from 'create-react-class';
import StripeCheckout from 'react-stripe-checkout';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { TextLoader } from '~/components/Loaders'

import { changeSubscription } from '~/actions/subscriptions'


var SubNavbar = createReactClass({
    displayName: 'SubNavbar',

    propTypes: {
		fetching: PropTypes.bool,
		user: PropTypes.object,
		dispatch: PropTypes.func
	},

    stripeConfig: {
		stripeKey: process.env.NODE_ENV === 'production' ? 'pk_live_BWQlfS9ubXu050yWSJ3yapQM' : 'pk_test_JR16I5d2htSAn7brnEAgVcAk',
		image: 'https://v.fastcdn.co/t/thumbnail/20170419/1492616078-15708596-150x150-default-dp-2.jpg',
	    name: 'Five to Nine Club Membership',
	    description: 'Access Five to Nine Club for 12 months for £20',
	    componentClass: 'span',
	    zipCode: false,
	    currency: 'GBP',
	    amount: 2000,
	    allowRememberMe: false,
	    triggerEvent: 'onClick'
	},

    componentDidMount: function() {
		this.stripeConfig.email = this.props.user.email;
	},

    receiveToken: function(data) {
		this.props.changeSubscription(4, 'month', data.id)
	},

    render: function() {
		return(
			<nav className="main-nav sub-nav bg-light-main">
		        <div className="container">
		        	<ul className="row">
						<li className="nav-left">
							{ !this.props.fetching 
								? <p className="text-white pbot5-xs">
									🎉 EXCLUSIVE 🎉 get 12 months of Boma membership for just £20
									<a href={"http://signup.bomacamp.com/5-to-9?email=" + this.props.user.email} className="mleft10 text-pale-main" target="_blank">
										What's coming up?
									</a>
									 | 
									<StripeCheckout {...this.stripeConfig} token={this.receiveToken}>
										<a href="#" className="text-pale-main">Yes please!</a>
									</StripeCheckout>
								</p>
								: <TextLoader classes="text-white" />
							}
						</li>
	            	</ul>
		    	</div>
		    </nav> 
		)
	},

})

const mapDispatchToProps = dispatch => bindActionCreators({ changeSubscription }, dispatch);

export default connect(
    null,
    mapDispatchToProps
)(SubNavbar);



// WEBPACK FOOTER //
// ./src/js/components/Header/components/SubNavbar.js